import styled from "styled-components";

export const ChallengeHeader = styled.div`
  display: flex;
  justify-content: space-between;

  input {
    width: 33%;
  }

  .col-new-challenge__wrapper {
    min-width: 220px;
  }

  .btn[data-testid^="challenge__suggest-new"] {
    max-width: calc(100% - 24px);
  }
`;
